import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { VendorService } from 'src/app/services/vendor.service';
import { VendorResponse } from 'src/app/models/vendor.model';
import { PurchaseOrderDetailRequest, PurchaseOrderRequest } from 'src/app/models/purchase-order.model';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductConversionService } from 'src/app/services/product-conversion.service';

@Component({
  selector: 'app-modal-create-purchase-order',
  templateUrl: './modal-create-purchase-order.component.html',
  styleUrls: ['./modal-create-purchase-order.component.scss']
})
export class ModalCreatePurchaseOrderComponent implements OnInit {
  loading = false;
  date = new Date();
  deliveryDate = new Date();
  providers = [];
  @Input() orderShowed: any;
  @Input() reverseTranformShowed: boolean = false;
  @Output() close = new EventEmitter<boolean>();
  @Output() downloadOrderPdf = new EventEmitter();
  newOrder: PurchaseOrderRequest = new PurchaseOrderRequest();
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    provider: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        type: null
      }
    }
  };
  warehouses: WarehouseResponse[] = [];
  products: ProductResponse[] = [];
  filterWarehouses: WarehouseResponse[] = [];
  filterProducts: ProductResponse[] = [];
  filterProviders: VendorResponse[] = [];
  timeout = null;
  quantity = 0;
  productList: any[] = [];
  allowedWarehouses: { [key: number]: boolean } = {};
  currencyType = 0;
  loadingCurrency = false;
  typeProduct: string = null;
  allowedReverse: { [key: number]: boolean } = {};
  productTransforms: { [key: number]: any[] } = {};

  constructor(
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private toastService: ToastrService,
    private orderService: PurchaseOrderService,
    private authService: AuthenticationService,
    private vendorService: VendorService,
    private inventoryService: InventoryService,
    private productConversionService: ProductConversionService
  ) {
    var getUserPosition = authService.getUserPosition();
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
  }

  ngOnInit(): void {
    this.getInitialData();

    if (this.orderShowed) {
      this.loadReservationData();
    }

    // this.vendorService.getProvidesByClue('').subscribe({
    //   next: (response: ResponseObject) => {
    //     this.providers = response.data;
    //     this.orderShowed['items'].forEach(element => {
    //       element['provider'].filterElements = response.data;
    //       element['existence'] = null;
    //     });
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastService.error(error.error.message);
    //   }
    // });
  }

  getInitialData() {
    this.getWarehouses("");
    this.getProducts("");
    this.getProviders("");
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  getWarehouses(clue) {
    this.warehouseService.getWarehouseByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses.filter((w) => {
          return this.allowedWarehouses[w.id];
        });
        if (this.filterWarehouses.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouses.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouses[0].name, true, null, 'fa-circle-check', this.filterWarehouses[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  getProductConversionByTarget(productTargetId: any) {
    this.productConversionService.getAllProductByProductTarget(productTargetId).subscribe({
      next: (res: any) => {
        console.log(res.data);
      },
      error: (err: any) => {
        this.toastService.error(err.error.description || "Error al Obtener producto de conversion")
      }
    });
  }

  showProductConversion(index: any) {
    this.allowedReverse[index] = true;
    const targetProduct: any = this.productList[index];
    this.getProductConversionByTarget(targetProduct.productData.id);
  }

  getProviders(clue) {
    this.vendorService.getProvidesByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.filterProviders = this.providers;
        if (this.filterProviders.length == 0) {
          this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
        } else if (this.filterProviders.length == 1) {
          this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    const warehouseId = this.inputs.warehouse.data?.id;

    this.productService.getAllProductsFilteredByFavorite(clue, warehouseId).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data
        this.filterProducts = this.products.filter((p) => {
          return this.typeProduct != null ? p.type == this.typeProduct : true;
        });
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  addProduct() {
    const originalProduct = { ...this.inputs.product.data };

    this.productList.push({
      productData: originalProduct,

      // Referencia inmutable para volver a consultar alternativas.
      originalProductData: originalProduct,
      originalQuantity: this.quantity,

      quantity: this.quantity,
      cost: 0,
      lastCost: 0,

      // Estado del selector de alternativas.
      showAlternativeSelector: false,
      loadingAlternatives: false,
      savingAlternative: false,
      alternativeProducts: [],
      selectedAlternativeId: null
    });

    this.getLastCost(this.productList[this.productList.length - 1]);
    this.inputs.product.value = "";
    this.quantity = 0;
    if (this.typeProduct == null) {
      this.typeProduct = this.inputs.product.data.type;
    }
    this.getProducts('');
  }

  deleteProductFromList(index: number) {
    this.productList.splice(index, 1);
    if (this.productList.length == 0) {
      this.typeProduct = null;
      this.getProducts('');
    }
  }

  writeWarehouse(input) {
    const inputValue: string = input.target.value;

    this.filterWarehouses = this.warehouses.filter((w) => {
      return w.name.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) || w.code.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
    })
  }


  writeProvider(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.provider.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProviders(inputValue);
    }, 500);
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
    this.getProducts('');
  }

  checkProvider(provider: VendorResponse) {
    this.inputs.provider.class = "fa-circle-check";
    this.inputs.provider.verified = true;
    this.inputs.provider.data = provider;
    this.inputs.provider.value = provider.name;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: WarehouseResponse) {
    this.changeInput(this.inputs.product, product.code + " - " + product.name, true, null, "fa-circle-check", product);
  }

  createOrder() {
    if (this.loading) {
      return;
    }
    for (let i = 0; i < this.productList.length; i++) {
      const element = this.productList[i];
      if (element.cost < 0) {
        return this.toastService.error(`El costo del producto ${element.productData.name} deber ser mayor o igual a cero.`);
      }
    }

    this.loading = true;
    this.newOrder.detail = [];


    this.productList.forEach((p) => {
      this.newOrder.detail.push(
        new PurchaseOrderDetailRequest(p.productData.id, this.inputs.warehouse.data.id, p.quantity, 0, p.cost)
      );
    })
    this.newOrder.creationDate = new Date(this.date);
    this.newOrder.deliveryDate = new Date(this.deliveryDate);
    this.newOrder.provider = this.inputs.provider.data.id;
    this.newOrder.currency = this.currencyType;
    this.orderService.addOrder(this.newOrder).subscribe({
      next: (response: ResponseObject) => {
        this.newOrder = new PurchaseOrderRequest();
        this.toastService.success("Orden de Compra creada correctamente!");
        this.loading = false;

        this.downloadOrderPdf.emit(response.data);
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  get total() {
    return this.productList.reduce((sum, item) => sum + (item.quantity * item.cost), 0);
  }

  updateExchange() {
    if (this.currencyType == 0) {
      this.currencyType = 1;
    } else {
      this.currencyType = 0;
    }
  }

  getLastCost(row: any) {
    this.inventoryService.getLasCostProduct(row.productData.id).subscribe({
      next: (res: any) => {
        row.lastCost = res.data;
      },
      error: (err: any) => { }
    });
  }

  loadReservationData() {
    if (!this.orderShowed) {
      return;
    }

    const reservation = this.orderShowed.reservation;
    const details = this.orderShowed.details || [];

    if (reservation?.warehouseData) {

      this.inputs.warehouse.value =
        reservation.warehouseData.name;

      this.inputs.warehouse.data =
        reservation.warehouseData;

      this.inputs.warehouse.verified = true;

      this.inputs.warehouse.class =
        'fa-circle-check';
    }

    this.productList = details.map((detail: any) => {

      return {

        productData:
          detail.productData || {
            id: detail.productId,
            name: detail.productName,
            code: detail.productCode,
            type: detail.productType
          },
        originalProductData:
          detail.productData || {
            id: detail.productId,
            name: detail.productName,
            code: detail.productCode,
            type: detail.productType
          },
        originalQuantity: Number(detail.quantity || 0),

        quantity: Number(detail.quantity || 0),
        cost: 0,
        lastCost: 0
      };

    });

    if (
      this.productList.length > 0 &&
      this.productList[0].productData
    ) {
      this.typeProduct =
        this.productList[0].productData.type || null;
    }

    this.inputs.provider.value = null;
    this.inputs.provider.data = {
      id: null
    };

    this.inputs.provider.verified = false;
    this.getLastCostAll();
    console.log(this.productList);

  }

  getLastCostAll() {
    for (let i = 0; i < this.productList.length; i++) {
      this.getLastCost(this.productList[i]);
    }
  }


  openProductAlternatives(product: any): void {
    if (product.loadingAlternatives || product.savingAlternative) {
      return;
    }

    // Abrir el selector y limpiar la selección anterior.
    product.showAlternativeSelector = true;
    product.selectedAlternativeId = null;
    product.loadingAlternatives = true;

    // Siempre consultar usando el producto inicial.
    const originalProductId = product.originalProductData.id;


    // Reemplaza este método por el nombre real de tu servicio.
    this.productConversionService.getAllProductByProductTarget(originalProductId)
      .subscribe({
        next: (response: ResponseObject) => {
          console.log(response.data);

          product.alternativeProducts = response.data ?? [];

          if (product.alternativeProducts.length === 0) {
            this.toastService.info(
              'No se encontraron productos alternativos.'
            );
            product.showAlternativeSelector = false;
            return;
          }

          // Si la lista contiene el producto actual, seleccionarlo
          // inicialmente; de lo contrario, exigir una elección.
          const currentProductExists =
            product.alternativeProducts.some(
              (p: ProductResponse) =>
                p.id === product.productData.id
            );

          product.selectedAlternativeId = currentProductExists
            ? product.productData.id
            : null;
        },
        error: (error: HttpErrorResponse) => {
          product.showAlternativeSelector = false;
          this.toastService.error(
            error.error?.message ??
            'No se pudieron obtener los productos alternativos.'
          );
        },
        complete: () => {
          product.loadingAlternatives = false;
        }
      });
  }

  saveProductAlternative(product: any): void {
    if (
      product.selectedAlternativeId == null ||
      product.savingAlternative
    ) {
      return;
    }

    const selectedProduct = product.alternativeProducts.find(
      (p: ProductResponse) =>
        p.parentProduct.id === product.selectedAlternativeId
    );

    if (!selectedProduct) {
      this.toastService.warning(
        'Selecciona un producto válido.'
      );
      return;
    }

    if (selectedProduct.id === product.productData.id) {
      product.showAlternativeSelector = false;
      return;
    }

    product.savingAlternative = true;

    // Actualizar la fila solo después de validar las existencias.
    product.productData = selectedProduct.parentProduct;

    // Cerrar el selector después de guardar.
    product.showAlternativeSelector = false;
    product.alternativeProducts = [];
    product.selectedAlternativeId = null;
    product.quantity = product.quantity / selectedProduct.factor;

    product.savingAlternative = false;
  }

  cancelProductAlternative(product: any): void {
    if (product.savingAlternative) {
      return;
    }

    product.showAlternativeSelector = false;
    product.alternativeProducts = [];
    product.selectedAlternativeId = null;
  }

}
